export const reassignSigneeToolTestIds = {
  signeeLabel: 'reassign-signee-label',
};
